import { gql } from '@apollo/client';

const getFileSignedURLQuery = gql `
    query ($urlInput: FileSignedWithURL, $input: FileSignedWithGatingInput) {
      getFileSignedURL(urlInput: $urlInput, input: $input)
      {
        mediaURL
        type
        contentType
        expiryDuration
      }
    }
  `;

export { getFileSignedURLQuery };
